module.exports = __webpack_public_path__ + "static/media/CV.8715e231.pdf";